import { Button } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <LockOutlinedIcon style={{ fontSize: '64px', color: '#f44336', marginBottom: '20px' }} />
        <h1 style={{ color: '#333', marginBottom: '16px' }}>Access Denied</h1>
        <p style={{ color: '#666', marginBottom: '24px', lineHeight: '1.6' }}>
          You don't have permission to access this page. Please make sure you're logged in with the
          correct credentials.
        </p>
        <Button variant="outlined" color="neutral" onClick={() => navigate('/login')}>
          Return to Login
        </Button>
      </div>
    </div>
  );
}
